import { mount } from "@vue/test-utils";
import DniInput from "@/components/core/composite/DniInput";

describe("DniInput component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(DniInput);
  });

  it("Renders del component DniInput", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
